export default "__VITE_ASSET__DsCNCQ9j__"